import React from 'react'
import PageHeader from '@/components/PageHeader'
import { RenderBlocks } from '../RenderBlocks'
export type PageHeaderBlockProps = {
  backUrl: string
  title: string
  subtitle?: string
  rightContent?: { id?: string | null; blockType: string; blockName?: string | null }[]
  sticky?: boolean
  blockType: 'pageHeader'
}

export const PageHeaderBlock: React.FC<PageHeaderBlockProps> = ({
  backUrl,
  title,
  subtitle,
  rightContent,
  sticky = false,
}) => {
  return (
    <PageHeader
      backUrl={backUrl}
      title={title}
      subtitle={subtitle}
      sticky={sticky}
      rightContent={rightContent ? <RenderBlocks blocks={rightContent} /> : undefined}
    />
  )
}